function cov_23ud97wbo2() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/KineticGrid.tsx";
    var hash = "8de2366569b72914af708c83bca0c59a712060cb";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/KineticGrid.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 19,
                    column: 25
                },
                end: {
                    line: 19,
                    column: 53
                }
            },
            "1": {
                start: {
                    line: 21,
                    column: 30
                },
                end: {
                    line: 66,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 23,
                    column: 2
                },
                end: {
                    line: 23,
                    column: 58
                }
            },
            "3": {
                start: {
                    line: 24,
                    column: 23
                },
                end: {
                    line: 24,
                    column: 45
                }
            },
            "4": {
                start: {
                    line: 26,
                    column: 2
                },
                end: {
                    line: 27,
                    column: 12
                }
            },
            "5": {
                start: {
                    line: 29,
                    column: 18
                },
                end: {
                    line: 29,
                    column: 31
                }
            },
            "6": {
                start: {
                    line: 31,
                    column: 22
                },
                end: {
                    line: 33,
                    column: 39
                }
            },
            "7": {
                start: {
                    line: 35,
                    column: 1
                },
                end: {
                    line: 44,
                    column: 4
                }
            },
            "8": {
                start: {
                    line: 36,
                    column: 2
                },
                end: {
                    line: 43,
                    column: 3
                }
            },
            "9": {
                start: {
                    line: 37,
                    column: 3
                },
                end: {
                    line: 40,
                    column: 6
                }
            },
            "10": {
                start: {
                    line: 42,
                    column: 3
                },
                end: {
                    line: 42,
                    column: 37
                }
            },
            "11": {
                start: {
                    line: 46,
                    column: 20
                },
                end: {
                    line: 59,
                    column: 2
                }
            },
            "12": {
                start: {
                    line: 47,
                    column: 2
                },
                end: {
                    line: 56,
                    column: 3
                }
            },
            "13": {
                start: {
                    line: 51,
                    column: 3
                },
                end: {
                    line: 55,
                    column: 5
                }
            },
            "14": {
                start: {
                    line: 58,
                    column: 2
                },
                end: {
                    line: 58,
                    column: 21
                }
            },
            "15": {
                start: {
                    line: 61,
                    column: 1
                },
                end: {
                    line: 65,
                    column: 3
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 21,
                        column: 30
                    },
                    end: {
                        line: 21,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 49
                    },
                    end: {
                        line: 66,
                        column: 1
                    }
                },
                line: 21
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 35,
                        column: 17
                    },
                    end: {
                        line: 35,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 23
                    },
                    end: {
                        line: 44,
                        column: 2
                    }
                },
                line: 35
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 46,
                        column: 20
                    },
                    end: {
                        line: 46,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 26
                    },
                    end: {
                        line: 59,
                        column: 2
                    }
                },
                line: 46
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 23,
                        column: 2
                    },
                    end: {
                        line: 23,
                        column: 58
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 23,
                            column: 2
                        },
                        end: {
                            line: 23,
                            column: 32
                        }
                    }, {
                        start: {
                            line: 23,
                            column: 36
                        },
                        end: {
                            line: 23,
                            column: 58
                        }
                    }],
                line: 23
            },
            "1": {
                loc: {
                    start: {
                        line: 26,
                        column: 2
                    },
                    end: {
                        line: 27,
                        column: 12
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 26,
                            column: 3
                        },
                        end: {
                            line: 26,
                            column: 33
                        }
                    }, {
                        start: {
                            line: 26,
                            column: 37
                        },
                        end: {
                            line: 26,
                            column: 44
                        }
                    }, {
                        start: {
                            line: 26,
                            column: 48
                        },
                        end: {
                            line: 26,
                            column: 59
                        }
                    }, {
                        start: {
                            line: 27,
                            column: 2
                        },
                        end: {
                            line: 27,
                            column: 12
                        }
                    }],
                line: 26
            },
            "2": {
                loc: {
                    start: {
                        line: 36,
                        column: 2
                    },
                    end: {
                        line: 43,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 36,
                            column: 2
                        },
                        end: {
                            line: 43,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 36
            },
            "3": {
                loc: {
                    start: {
                        line: 47,
                        column: 2
                    },
                    end: {
                        line: 56,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 47,
                            column: 2
                        },
                        end: {
                            line: 56,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 47
            },
            "4": {
                loc: {
                    start: {
                        line: 48,
                        column: 3
                    },
                    end: {
                        line: 49,
                        column: 38
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 48,
                            column: 4
                        },
                        end: {
                            line: 48,
                            column: 21
                        }
                    }, {
                        start: {
                            line: 48,
                            column: 25
                        },
                        end: {
                            line: 48,
                            column: 38
                        }
                    }, {
                        start: {
                            line: 49,
                            column: 4
                        },
                        end: {
                            line: 49,
                            column: 20
                        }
                    }, {
                        start: {
                            line: 49,
                            column: 24
                        },
                        end: {
                            line: 49,
                            column: 37
                        }
                    }],
                line: 48
            },
            "5": {
                loc: {
                    start: {
                        line: 63,
                        column: 4
                    },
                    end: {
                        line: 63,
                        column: 48
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 63,
                            column: 18
                        },
                        end: {
                            line: 63,
                            column: 33
                        }
                    }, {
                        start: {
                            line: 63,
                            column: 36
                        },
                        end: {
                            line: 63,
                            column: 48
                        }
                    }],
                line: 63
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0
        },
        b: {
            "0": [0, 0],
            "1": [0, 0, 0, 0],
            "2": [0, 0],
            "3": [0, 0],
            "4": [0, 0, 0, 0],
            "5": [0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "8de2366569b72914af708c83bca0c59a712060cb"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_23ud97wbo2 = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_23ud97wbo2();
import * as Sentry from '@sentry/react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { URL } from 'vio-constants';
import { isAuth0Authenticated, isMaintenance, useReduxState } from 'vio-libs';
import SentryComponent from '../global/Sentry';
import App from './App';
import Gateway from './Gateway';
import Maintenance from './Maintenance';
import 'vio-components/src/sass/index.scss';
const useSessionCookie = (cov_23ud97wbo2().s[0]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.server_side_cookies);
cov_23ud97wbo2().s[1]++;
const KineticGrid = () => {
    cov_23ud97wbo2().f[0]++;
    const maintenance = (cov_23ud97wbo2().s[2]++, (cov_23ud97wbo2().b[0][0]++, typeof vaporio !== 'undefined') && (cov_23ud97wbo2().b[0][1]++, isMaintenance(vaporio)));
    const authenticated = (cov_23ud97wbo2().s[3]++, isAuth0Authenticated());
    const sentryURL = (cov_23ud97wbo2().s[4]++, (cov_23ud97wbo2().b[1][0]++, typeof vaporio !== 'undefined') && (cov_23ud97wbo2().b[1][1]++, vaporio) && (cov_23ud97wbo2().b[1][2]++, vaporio.dsn) || (cov_23ud97wbo2().b[1][3]++, URL.SENTRY));
    const navigate = (cov_23ud97wbo2().s[5]++, useNavigate());
    const unauthorized = (cov_23ud97wbo2().s[6]++, useReduxState('interceptorsResponse.unauthorized'));
    cov_23ud97wbo2().s[7]++;
    React.useEffect(() => {
        cov_23ud97wbo2().f[1]++;
        cov_23ud97wbo2().s[8]++;
        if (!maintenance) {
            cov_23ud97wbo2().b[2][0]++;
            cov_23ud97wbo2().s[9]++;
            Sentry.init({
                dsn: sentryURL,
                release: `kg-portal@${VERSION}`
            });
            cov_23ud97wbo2().s[10]++;
            Sentry.setTag('version', VERSION);
        }
        else {
            cov_23ud97wbo2().b[2][1]++;
        }
    });
    cov_23ud97wbo2().s[11]++;
    const renderView = () => {
        cov_23ud97wbo2().f[2]++;
        cov_23ud97wbo2().s[12]++;
        if ((cov_23ud97wbo2().b[4][0]++, !useSessionCookie) && (cov_23ud97wbo2().b[4][1]++, authenticated) || (cov_23ud97wbo2().b[4][2]++, useSessionCookie) && (cov_23ud97wbo2().b[4][3]++, !unauthorized)) {
            cov_23ud97wbo2().b[3][0]++;
            cov_23ud97wbo2().s[13]++;
            return React.createElement(SentryComponent, null, React.createElement(App, null));
        }
        else {
            cov_23ud97wbo2().b[3][1]++;
        }
        cov_23ud97wbo2().s[14]++;
        return React.createElement(Gateway, null);
    };
    cov_23ud97wbo2().s[15]++;
    return React.createElement("div", {
        id: "kinetic-grid-container"
    }, maintenance ? (cov_23ud97wbo2().b[5][0]++, React.createElement(Maintenance, null)) : (cov_23ud97wbo2().b[5][1]++, renderView()));
};
export default KineticGrid;
